import { render, staticRenderFns } from "./AddOrderCommercialInvoiceView.vue?vue&type=template&id=89e04afa&scoped=true&"
import script from "./AddOrderCommercialInvoiceView.vue?vue&type=script&lang=js&"
export * from "./AddOrderCommercialInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderCommercialInvoiceView.vue?vue&type=style&index=0&id=89e04afa&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e04afa",
  null
  
)

component.options.__file = "AddOrderCommercialInvoiceView.vue"
export default component.exports